// Eventi GA4 (via GTM dataLayer) del costruttore di costi deducibili.
// Convenzione del sito: push su window.dataLayer con { event, ...props },
// GTM inoltra a GA4. Nessun dato finanziario negli eventi: solo contatori
// e flag, mai gli importi inseriti dall'utente.
const push = (event, params = {}) => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
};

// "Aperto" conta una volta per pagina: interessa quanti scoprono il tool,
// non i rimbalzi apri/chiudi.
let openInviato = false;
export function trackBuilderOpen() {
    if (openInviato) return;
    openInviato = true;
    push('costi_builder_open');
}

// "Applicato" a ogni uso effettivo: numero di categorie compilate e quali
// limiti sono scattati (tetti/plafond), che sono il valore informativo del tool.
export function trackBuilderApply({ categorie, conTetto, conPlafond }) {
    push('costi_builder_apply', {
        categorie_compilate: categorie,
        limiti_tetto: conTetto,
        limiti_plafond: conPlafond
    });
}

// L'utente ha riscritto a mano il campo costi dopo aver usato il costruttore:
// il dettaglio si scollega. Conta una volta per pagina.
let detachInviato = false;
export function trackBuilderDetach() {
    if (detachInviato) return;
    detachInviato = true;
    push('costi_builder_detach');
}

// Il blocco "sostenuti vs dedotti" e' stato mostrato nella pagina risultati.
let confrontoInviato = false;
export function trackConfrontoVisto() {
    if (confrontoInviato) return;
    confrontoInviato = true;
    push('costi_confronto_visto');
}
